import moment from 'moment'
import DisplayMessage from '../data/DisplayMessage'
import {TerminalType, Transaction, TransactionStatus, TransactionType} from '../data/Transaction'
import StatusResult from '../data/StatusResult'
import TerminalInfo from '../data/TerminalInfo'

const value = (val, def: any = null) => (val !== undefined && val !== null ? val : def)

export const transactionResult = (id, type, params, error: any = null) =>
    new Transaction({
        amount: value(params.amount, 0) / (type === TransactionType.REFUND ? -100 : 100),
        cardName: value(params.card_name),
        cardReadingMethod: value(params.card_reading_method),
        currency: value(params.currency, 'EUR'),
        customerReceipt: value(params.customer_receipt ? params.customer_receipt.text : ''),
        errorCode: error ? value(error.code) : null,
        errorMessage: error ? value(error.message) : null,
        id,
        merchantReceipt: value(params.merchant_receipt ? params.merchant_receipt.text : ''),
        offline: value(params.offline, false),
        paymentMethod: value(params.payment_method),
        responseCode: value(params.response_code),
        responseMessage: value(params.response_text),
        status: TransactionStatus.CLOSED,
        terminalType: TerminalType.POPLATEK,
        terminalResult: params,
        terminalResultJson: JSON.stringify(params),
        transactionId: value(params.transaction_id),
        transactionTime: params.transaction_time ? moment(params.transaction_time, 'DDMMYYHHmmss') : null,
        transactionType: type,
        transactionUniqueId: value(params.transaction_unique_id),
    })

export const displayMessage = (params) =>
    new DisplayMessage({
        message: params.message,
    })

export const statusResult = (params) =>
    new StatusResult({
        pendingTransactionCount: value(params.pending_transaction_count, 0),
        pspConnectionAvailable: value(params.psp_connection_available, false),
        readyForTransaction: value(params.ready_for_transaction, false),
        transactionStatus: value(params.transaction_status),
    })

export const terminalInfo = (params) =>
    new TerminalInfo({
        printMaxHeight: value(params.printer ? params.printer.max_height : 100),
        printMaxWidth: value(params.printer ? params.printer.max_width : 100),
        terminalId: params.terminal_id ? params.terminal_id.toString() : null,
        terminalType: TerminalType.POPLATEK,
    })
